'use client';

import { Package } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useRepScoreStore } from '@/presentation/hooks/useStores';
import {
  ScoreCard,
  StatusTile,
  EarnRows,
  DrawerWhy,
  DrawerCTA,
  DEFAULT_DRAWER_WHY_COPY,
} from '../shared';

interface ProgressingStateProps {
  onStartPlan?: () => void;
}

/**
 * STATE 2: Progressing (existing history or intermediate trust growth)
 *
 * Same shell as NewUserState. Differentiates via the live on-time payment
 * count in the helper line.
 */
export const ProgressingState = observer(function ProgressingState({
  onStartPlan,
}: ProgressingStateProps) {
  const repScoreStore = useRepScoreStore();
  const score = repScoreStore.currentScore;
  const tier = repScoreStore.trustTier;
  const nextTierScore = repScoreStore.tierConfig.nextTierScore ?? undefined;
  const onTime = repScoreStore.scoreBreakdown?.paymentHistory?.onTimePayments ?? 0;
  const helper = `${onTime} on-time ${onTime === 1 ? 'payment' : 'payments'} on your record. Keep paying on time.`;

  return (
    <div className="flex flex-col gap-[18px]">
      <ScoreCard
        score={score}
        tier={tier}
        helper={helper}
        progressToScore={nextTierScore}
      />

      <StatusTile
        variant="info"
        icon={<Package className="size-4 text-white" />}
        title="Early Pickup not eligible yet"
        body="Keep paying on time. We'll let you know when you qualify."
      />

      <EarnRows />

      <DrawerWhy body={DEFAULT_DRAWER_WHY_COPY} />

      <DrawerCTA label="Got it" onClick={onStartPlan} />
    </div>
  );
});

export default ProgressingState;
